/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line
  
  // Custom event listener for cart refresh and drawer open
  document.addEventListener('custom:cart:refresh', function(event) {
    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      // Manually trigger cart refresh - this will also open the cart drawer
      cartItems.getCart();
    }
  });
  
  // ------------------------------------------------------------------
  // Currently: keep the selected size when switching color (sibling) products.
  // - Same size exists in new color  -> open new color with that size selected
  // - Size exists but sold out       -> open with that size selected (shows sold out)
  // - Size doesn't exist in new color -> open with no size selected + "Select a size"
  // ------------------------------------------------------------------
  (function crSizeCarry() {
    if (window.__crSizeCarry) return;
    window.__crSizeCarry = true;

    var SIZE_NAME = /^options\[size\]/i;
    var PICK_PARAM = 'pick_size';
    var PICK_TEXT = 'Select a size';
    var pending = false;
    var cache = {};

    function sizeRadios(scope) {
      var all = (scope || document).querySelectorAll('input[data-single-option-selector]');
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (SIZE_NAME.test(all[i].name || '')) out.push(all[i]);
      }
      return out;
    }

    function currentSize(scope) {
      if (pending) return null;
      var inputs = sizeRadios(scope);
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (el.type === 'radio') {
          if (el.checked) return el.value;
        } else if (el.value) {
          return el.value;
        }
      }
      return null;
    }

    function productJsonUrl(href) {
      var u = new URL(href, window.location.origin);
      return u.pathname.replace(/\/$/, '') + '.js';
    }

    function loadProduct(href) {
      var key = productJsonUrl(href);
      if (!cache[key]) {
        cache[key] = fetch(key, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.json();
        });
        cache[key].catch(function () { delete cache[key]; });
      }
      return cache[key];
    }

    function findVariantId(product, size) {
      var pos = -1;
      var opts = product.options || [];
      for (var i = 0; i < opts.length; i++) {
        var name = typeof opts[i] === 'string' ? opts[i] : opts[i].name;
        if (String(name).toLowerCase() === 'size') { pos = i; break; }
      }
      if (pos < 0) return null;
      var key = 'option' + (pos + 1);
      var target = String(size).trim().toLowerCase();
      var match = null;
      (product.variants || []).forEach(function (v) {
        if (String(v[key]).trim().toLowerCase() === target) {
          if (!match || (!match.available && v.available)) match = v;
        }
      });
      return match ? match.id : null;
    }

    function siblingLink(target) {
      var a = target && target.closest ? target.closest('a.sibling__link') : null;
      if (!a || a.hasAttribute('data-quick-add-btn')) return null;
      return a;
    }

    // Warm the cache on hover / touch so the switch feels instant
    ['mouseover', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var a = siblingLink(e.target);
        if (a) loadProduct(a.href).catch(function () {});
      }, { passive: true, capture: true });
    });

    document.addEventListener('click', function (e) {
      var a = siblingLink(e.target);
      if (!a) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var scope = a.closest('.shopify-section') || document;
      var size = currentSize(scope);
      var base = new URL(a.href, window.location.origin);
      base.searchParams.delete('variant');
      base.searchParams.delete(PICK_PARAM);

      // Customer hasn't picked a size yet: carry the "please pick" state forward
      if (!size) {
        if (pending) {
          e.preventDefault();
          base.searchParams.set(PICK_PARAM, '1');
          window.location.href = base.pathname + base.search;
        }
        return;
      }

      e.preventDefault();
      var done = false;
      function go(url) {
        if (done) return;
        done = true;
        window.location.href = url.pathname + url.search;
      }
      var fallback = setTimeout(function () { go(base); }, 2500);

      loadProduct(a.href).then(function (product) {
        clearTimeout(fallback);
        var id = findVariantId(product, size);
        if (id) base.searchParams.set('variant', id);
        else base.searchParams.set(PICK_PARAM, '1');
        go(base);
      }).catch(function () {
        clearTimeout(fallback);
        go(base);
      });
    }, true);

    // ---- "Select a size" state when the size didn't exist in the new color ----
    function addButtons() {
      return document.querySelectorAll(
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"], [data-add-to-cart]'
      );
    }

    function lockButtons() {
      var btns = addButtons();
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.hasAttribute('data-cr-locked')) continue;
        b.setAttribute('data-cr-locked', '');
        b.setAttribute('data-cr-html', b.innerHTML);
        b.setAttribute('data-cr-disabled', b.disabled ? '1' : '0');
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        var label = b.querySelector('[data-add-to-cart-text]') || b.querySelector('span') || b;
        label.textContent = PICK_TEXT;
      }
    }

    function unlockButtons() {
      var btns = document.querySelectorAll('[data-cr-locked]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        b.innerHTML = b.getAttribute('data-cr-html');
        b.disabled = b.getAttribute('data-cr-disabled') === '1';
        if (!b.disabled) b.removeAttribute('aria-disabled');
        b.removeAttribute('data-cr-locked');
        b.removeAttribute('data-cr-html');
        b.removeAttribute('data-cr-disabled');
      }
    }

    function applyPickState() {
      var radios = sizeRadios(document).filter(function (r) { return r.type === 'radio'; });
      if (!radios.length) { pending = false; return; }
      radios.forEach(function (r) { r.checked = false; });
      var fs = radios[0].closest('fieldset');
      var label = fs && fs.querySelector('[data-option-value]');
      if (label) label.textContent = PICK_TEXT;
      lockButtons();
    }

    function initPick() {
      var params = new URLSearchParams(window.location.search);
      if (params.get(PICK_PARAM) !== '1') return;
      pending = true;
      params.delete(PICK_PARAM);
      var qs = params.toString();
      try {
        window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      } catch (err) {}
      applyPickState();
      // Re-apply once more after the theme finishes its own setup
      window.addEventListener('load', function () { if (pending) applyPickState(); });
    }

    // Customer picks a size: release the lock before the theme updates the form
    document.addEventListener('change', function (e) {
      if (!pending) return;
      var t = e.target;
      if (t && t.matches && t.matches('input[data-single-option-selector]') && SIZE_NAME.test(t.name || '')) {
        pending = false;
        unlockButtons();
      }
    }, true);

    // Safety net: never add a size the customer didn't choose
    function guard(e) {
      if (!pending) return;
      var t = e.target;
      var hit = t && t.closest && (
        t.closest('form[action*="/cart/add"]') ||
        t.closest('[data-add-to-cart]') ||
        t.closest('shopify-payment-button, .shopify-payment-button')
      );
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var radios = sizeRadios(document);
      var fs = radios.length && radios[0].closest('fieldset');
      if (fs && fs.scrollIntoView) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    document.addEventListener('submit', guard, true);
    document.addEventListener('click', function (e) {
      if (!pending) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[type="submit"], [name="add"], [data-add-to-cart], shopify-payment-button, .shopify-payment-button')) guard(e);
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPick);
    } else {
      initPick();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
